<template>
  <data-loader>
    <page-layout
      class="simulation-intro"
      data-test="simulation-intro"
    >
      <template #header>
        <simulation-header :title="simulation.name"></simulation-header>
      </template>
      <div
        class="simulation-page-content"
        v-html="html"
      >
      </div>
      <agree-pill
        v-if="requiresAgreement"
        @agree-checked="agreeChecked = true"
        @agree-unchecked="agreeChecked = false"
      ></agree-pill>
      <template #footer>
        <page-footer
          :button-text="isLastPage ? 'Start' : 'Next'"
          :requires-agreement="requiresAgreement"
          :agree-checked="agreeChecked"
          @next-button-clicked="nextPage"
        ></page-footer>
      </template>
    </page-layout>
  </data-loader>
</template>

<script>
import WuxSimulationsMixin from '@/mixins/wux-simulations';
import PageLayout from '@components/sims/single-section-sim/PageLayout.vue';
import SimulationHeader from '@components/sims/single-section-sim/SimulationHeader.vue';
import AgreePill from '@components/sims/single-section-sim/AgreePill.vue';
import PageFooter from '@components/sims/single-section-sim/PageFooter.vue';
import DataLoader from '@/components/sims/DataLoader.vue';

export default {
  components: {
    AgreePill,
    PageLayout,
    PageFooter,
    SimulationHeader,
    DataLoader,
  },
  mixins: [WuxSimulationsMixin],
  data: () => ({
    agreeChecked: false,
  }),
  computed: {
    pageNum() {
      return +this.$route?.params['pageNum'];
    },
    pages() {
      return this.simulation.introText?.split('<!-- page break -->') || ['Intro text is not found. It can be edited, by editing this category in the CMS.'];
    },
    html() {
      return this.pages[this.pageNum - 1];
    },
    isLastPage() {
      return this.pageNum === this.pages.length;
    },
    requiresAgreement() {
      return this.html?.toLowerCase().includes('i agree');
    },
  },
  methods: {
    nextPage() {
      if (this.isLastPage) {
        return this.setCategoryState(this.simulation, this.inProgressStatus).then(() => {
          return this.$router.push({
            name: 'simFlashcard#show',
            params: {
              simId: this.simulation.id,
              flashcardId: this.flashcardStatesOrdered[0].flashcardId,
            },
          });
        });
      }
      return this.$router.push({
        name: 'sims#intro',
        params: {
          simId: this.simulation.id,
          pageNum: this.pageNum + 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.simulation-intro {
  .simulation-page-content {
    font-size: 1.25rem;
    padding: 1.25rem;

    h1, h2, h3, h4, h5, h6 {
      font-size: 1.25rem;
    }
  }
}
</style>
